import { render, staticRenderFns } from "./presImportF.vue?vue&type=template&id=1201b9fb"
import script from "./presImportF.vue?vue&type=script&lang=js"
export * from "./presImportF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports